export const esc = (s) =>
  String(s ?? "").replace(/[&<>"']/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]));

export const rs = (n) => `₹${Number(n || 0).toFixed(2)}`;

const THERMAL_CSS = `
  * { box-sizing: border-box; }
  html, body { margin: 0; padding: 0; }
  body { font-family: Arial, Helvetica, sans-serif; font-size: 13px; color: #000; padding: 12px 10px; line-height: 1.35; font-variant-numeric: tabular-nums; }
  h1 { font-size: 22px; text-align: center; margin: 0 0 2px; letter-spacing: 3px; font-weight: 900; }
  h2 { font-size: 13px; margin: 0 0 4px; letter-spacing: 1.5px; font-weight: 900; text-transform: uppercase; }
  .tag { text-align: center; font-size: 11px; font-weight: 700; letter-spacing: 2px; margin-bottom: 10px; }
  .title { text-align: center; font-size: 15px; font-weight: 900; letter-spacing: 2px; border: 1.5px solid #000; padding: 4px 0; margin: 6px 0 8px; }
  .meta { text-align: center; font-size: 12px; margin-bottom: 6px; }
  .meta b { font-weight: 700; }
  hr { border: none; border-top: 1px dashed #000; margin: 10px 0; }
  table { width: 100%; border-collapse: collapse; }
  td { padding: 3px 0; vertical-align: top; font-size: 13px; }
  td.qty { width: 32px; font-weight: 700; }
  td.name { padding-right: 6px; }
  td.amt { text-align: right; white-space: nowrap; padding-left: 6px; font-weight: 700; }
  tr.total td { font-size: 16px; font-weight: 900; padding-top: 4px; }
  tr.sub td { font-size: 14px; font-weight: 900; border-top: 1px solid #000; padding-top: 4px; }
  .muted { color: #444; font-size: 11px; }
  .foot { text-align: center; margin-top: 14px; font-size: 11px; font-weight: 600; }
  .thanks { text-align: center; font-size: 13px; font-weight: 700; margin-top: 4px; }
  .tagline { text-align: center; font-size: 8px; font-style: italic; color: #666; margin-top: 8px; letter-spacing: 1px; }
  @media print { @page { margin: 4mm; } body { padding: 0; font-size: 13px; } }
`;

export function printThermal(title, bodyHtml) {
  const w = window.open("", "_blank", "width=340,height=640");
  if (!w) {
    window.print();
    return;
  }
  w.document.write(`<!doctype html><html><head><title>${esc(title)}</title><style>${THERMAL_CSS}</style></head><body>${bodyHtml}</body></html>`);
  w.document.close();
  w.focus();
  setTimeout(() => { w.print(); w.close(); }, 300);
}
